import * as React from 'react';
import { Box, Button, Divider, Drawer, List, ListItem, IconButton } from '@material-ui/core';
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

import HeaderMobileLogoImg from "../../Assets/Images/LandingPage/mobile_header_logo.svg";
import { ReactComponent as FacebookIcon } from "../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../Assets/Images/Header/TikTok.svg";
import { MobileHeaderContainer } from './MobileHeader.style';

import { SOCIAL_MEDIA_LINKS } from 'Helpers';
import { DrawerListContainer } from './MobileHeader.style';
import { Link, useNavigate } from 'react-router-dom';
import CustomButton from 'Components/Commons/CustomButton/CustomButton';

const MobileHeader = () => {
    const navigate = useNavigate();

    const handleLoginClick = () => {
        navigate("/login");
    };

    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => setOpen(!open);

    const handleNavClick = (path) => {
        if (path.includes("#")) {
            const [base, hash] = path.split("#");
            navigate(base);
            setTimeout(() => {
                const element = document.getElementById(hash);
                if (element) element.scrollIntoView({ behavior: "smooth" });
            }, 100);
        } else {
            navigate(path);
        }
        setOpen(false); // Close drawer after click
    };

    const DrawerList = (
        <DrawerListContainer>
            <Box role="presentation">
                {/* Top Row: Logo + Close Button */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "15px 25px",
                        borderBottom: "1px solid #00000017"
                    }}
                >
                    <div className="drawer_logo">
                        <Link to="/">
                            <img src={HeaderMobileLogoImg} alt="Mobile Logo" style={{ maxWidth: "120px" }} />
                        </Link>
                    </div>
                    <IconButton onClick={toggleDrawer}>
                        <CloseIcon />
                    </IconButton>
                </div>

                {/* Navigation Menu */}
                <List className="mobile_nav_menu">
                    {[
                        { text: "Home", path: "/" },
                        { text: "About Us", path: "/about-us" },
                        { text: "Subjects", path: "/subjects#subjects" },
                        { text: "Subscription Plan", path: "/subscription" },
                        { text: "Testimonials", path: "/testimonials" },
                        { text: "Contact Us", path: "/contact-us" },
                    ].map((item) => (
                        <ListItem
                            key={item.text}
                            button
                            onClick={() => handleNavClick(item.path)}
                            className={window.location.pathname === item.path ? "active" : ""}
                        >
                            {item.text}
                        </ListItem>
                    ))}
                </List>

                <Divider />

                {/* Social Icons */}
                <div className="mobile_social_icons" style={{ padding: "15px", textAlign: "center" }}>
                    <a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
                        <FacebookIcon />
                    </a>
                    <a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
                        <InstaIcon />
                    </a>
                    <a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
                        <TiktokIcon />
                    </a>
                </div>

                <Divider />

                {/* Buttons */}
                <div className="mobile_buttons" style={{ padding: "15px", textAlign: "center" }}>
                    <Link className='portal_login_link' to="/teacher/login">Portal Login</Link>
                    <div style={{ marginTop: "10px" }}>
                        <CustomButton
                            onClick={handleLoginClick}
                            text="Login"
                            className="customs_btn"
                        />
                    </div>
                </div>
            </Box>
        </DrawerListContainer>
    );

    return (
        <MobileHeaderContainer className='mobile_header_main'>
            <div className='mobile_header_wrapper'>
                <div className='mygrid-container'>
                    <div className='mygrid-row' style={{ alignItems: "center", justifyContent: "space-between" }}>
                        <div className='mygrid-col-md-6'>
                            <div className="header_mobile_logo">
                                <Link to="/">
                                    <img src={HeaderMobileLogoImg} alt="Mobile Logo" />
                                </Link>
                            </div>
                        </div>
                        <div className='mygrid-col-md-6' style={{ textAlign: "right" }}>
                            <Button onClick={toggleDrawer} className='close_menu_icon'>
                                <MenuIcon />
                            </Button>
                        </div>
                    </div>
                </div>
                <Drawer open={open} onClose={toggleDrawer} anchor='top' className='mobiles_drawer'>
                    {DrawerList}
                </Drawer>
            </div>
        </MobileHeaderContainer>
    );
}

export default MobileHeader;
